// extracted by mini-css-extract-plugin
export var alignCenter = "_br-d";
export var bannerShown = "_br-6";
export var buttonContent = "_br-0";
export var cardList = "_br-1";
export var centerContent = "_br-2";
export var chevron = "_br-3";
export var closePanelButton = "_br-k";
export var conversationContextContainer = "_br-l";
export var conversationDetailContainer = "_br-4";
export var detailWrapper = "_br-7";
export var dropdownButton = "_br-e";
export var dropdownTitle = "_br-9";
export var fullHeight = "_br-5";
export var hidden = "_br-a";
export var icon = "_br-b";
export var mergeSuggestionWrapper = "_br-m";
export var panel = "_br-i";
export var portalButtonsWrapper = "_br-c";
export var right = "_br-j";
export var tableSummaryContainer = "_br-8";
export var tableSummaryHeader = "_br-g";
export var threeDotsButton = "_br-f";
export var wide = "_br-h";